














import Vue from 'vue';
import Component from 'vue-class-component';
import {IBubble} from "../core/interface";
import {Watch} from "vue-property-decorator";

@Component({
    props: [
        'bubble'
    ]
})

export default class BubbleElement extends Vue {
    bubble: IBubble; // set the prop type
    scaleAdjusted: boolean = false;
    minimumTimePassed: boolean = false;
    textWaitTime: number = 200;
    $refs: {
        bubbleRef: HTMLElement,
        bubbleHeading: HTMLElement,
        bubbleText: HTMLElement
    }; // register ref types

    // watch for changes in bubble and calculate the overflow
    @Watch('bubble', { immediate: true, deep: true }) onBubbleChanged(val: any, oldVal: any) {
        this.$nextTick(this.calculateTextOverflow);
    };

    mounted() {
        // wait a minimum time of 200ms before showing content
        setTimeout(() => {
            this.minimumTimePassed = true;
        }, this.textWaitTime + (100 * this.bubble.priority));
    }

    /*
        Track event on bubble click
     */
    private bubbleClick(url: string): void {
        Vue.gtm.trackEvent({
            category: 'Landing',
            action: 'click',
            label: 'Bubble click',
            value: url
        });
    }

    /*
        When header or text overflows the bubble, then adjust it's scale so it would fit
     */
    private calculateTextOverflow(): void {
        if (this.bubble.contents[0].value) {
            const paddingSize: number = 50,
                bubbleSize: number = this.$refs.bubbleRef.clientWidth,
                headingSize: number = this.$refs.bubbleHeading.clientWidth + paddingSize,
                textSize: number = this.$refs.bubbleText.clientWidth + paddingSize;

            // check for heading overflow
            if (bubbleSize < headingSize) {
                this.$refs.bubbleHeading.style.transform = ('scale(' + (bubbleSize / headingSize) + ')');
            }

            // check for text overflow
            if (bubbleSize < textSize) {
                this.$refs.bubbleHeading.style.transform = ('scale(' + (bubbleSize / textSize) + ')');
            }

            this.scaleAdjusted = true;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bubble.vue